import { render, staticRenderFns } from "./NoAcademy.vue?vue&type=template&id=61336f4b&scoped=true&"
import script from "./NoAcademy.vue?vue&type=script&lang=js&"
export * from "./NoAcademy.vue?vue&type=script&lang=js&"
import style0 from "./NoAcademy.vue?vue&type=style&index=0&id=61336f4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61336f4b",
  null
  
)

export default component.exports